<svelte:head>

</svelte:head>
<script>

import Angebote from './Angebote.svelte';
import Last_update from './Last_update.svelte'
export let name;
// export let angebote;   
</script>

<main>


	<h1>{name}!</h1>
<Last_update/>
<Angebote/>
</main>

<style>

	main {
		text-align: center;
		/* padding: 1em; */
		max-width: 95%;
		margin: 0 auto;

	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 3em;
		font-weight: 100;
	}



</style>